// Path: src\Components\CustomerCare\TicketDetailPage.jsx
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { getTicketDetails, updateConversation } from '../../api/customerCare.api';
import { url } from '../../config/url';
import moment from 'moment';
import { useParams } from "react-router";

const TicketDetailPage = () => {
  const [inputMessage, setInputMessage] = useState('')
  const { id } = useParams();

  const [ticketInfo, setTicketInfo] = useState(null)
  const [conversations, setConversations] = useState([])
  const chatEndRef = useRef(null);
  useEffect(() => {
    if (chatEndRef.current) {
      if(conversations?.length>4)
      chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [conversations]);
  useEffect(() => {
    fetchTicketList()
  }, [id])
  const handlerSendMessage = () => {
    if (inputMessage.trim()) { // Check if there's a message to send
      console.log(inputMessage);
      setConversations(prev => [
        ...prev,
        {
          message: inputMessage,
          from: "appUser",
          dateAndTime: new Date()
        }
      ]);
      sendMessage(); // Assuming sendMessage sends the message to the backend or server
      setInputMessage(''); // Clear the input field after sending the message
    }
  };

  const fetchTicketList = async () => {
    try {
      const res = await getTicketDetails(id);
      if (res?.success && res?.data) {
        setTicketInfo(res?.data)
        setConversations(res?.data?.conversations)
      }
      else {
        setTicketInfo(null);
        setConversations([]);
      }
    } catch (error) {
      setTicketInfo(null);
      setConversations([]);
    }
  };
  const sendMessage = async () => {
    try {
      let data = [...conversations];
      data.push({ message: inputMessage, from: "appUser", dateAndTime: new Date() });
      console.log(data)
      const res = await updateConversation({
        _id: ticketInfo?._id,
        conversations: data,
        status: 3,
      });
      if (res?.success && res?.data) {
        //setTicketInfo(res?.data)
        //setConversations(res?.data?.conversations)
      }
      else {
        //setTicketInfo("");
        //setConversations([]);
      }
    } catch (error) {
      setTicketInfo(null);
      setConversations([]);
    }
  };
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handlerSendMessage();
    }
  };
  const checkStatus = (ticket) => {
    if (ticket?.status === "Call Request" || ticket?.status === "Replied" || ticket?.status === "In Progress") {
      return (<div className={`status-circle me-2 bg-inProcess`}></div>)
    }
    else if (ticket?.status === "Rejected") {
      return (<div className={`status-circle me-2 bg-cancelled`}></div>)
    }
    else if (ticket?.status === "Auto Approved") {
      return (<div className={`status-circle me-2 bg-completed`}></div>)
    }
    return (<div className={`status-circle me-2 bg-pending`}></div>)
  }

  return (
    <>
      <div >
      <div className='ticket-box mb-4' style={{ height: "auto" }}  key={ticketInfo?.screenShot?.default}>
        <div className='d-flex justify-content-between align-items-center flex-row-reverse'>
          <span className='f-14'>ID: #{ticketInfo?.code}</span>
          <div className={`f-14 `} >
            {checkStatus(ticketInfo)}status - {ticketInfo?.status}
          </div>
        </div>
        <div className='msg-box mt-3'>
          <p className='f-12 mb-0'>{moment(ticketInfo?.createdAt).format('DD/MM/YYYY')}</p>
          <p className='f-14 mb-0'>{ticketInfo?.description}</p>
        </div>
          {console.log("III",url?.IMAGE_URL + ticketInfo?.screenShot?.default)}
          {ticketInfo?.screenShot?.default !== undefined &&
          <div className='msg-box mt-3' style={{height:"15rem"}}>
            <img
              key={ticketInfo?.screenShot?.default}
              src={url?.IMAGE_URL + ticketInfo?.screenShot?.default}
              alt="Ticket screenshot"
              style={{objectFit:"cover"}}
            />
          </div>
        }
      </div>
      <div
      style={{height:"auto",overflowY:"none"}}
        className={`conversation scroll-none pb-4 pt-4 ${ticketInfo?.status?.toLowerCase() === "rejected" ||
            ticketInfo?.status?.toLowerCase() === "approved"
            ? "conversation-fullwidth"
            : ""
          }`}
      >
        {
          conversations.map((conversation, index) => {
            return (
              <div className='position-relative  mb-3' key={index}>
                <div className={`message-box d-flex align-items-center ${conversation.from !== "appUser" ? "justify-content-start " : "reply justify-content-end"}`}>
                  <p className={`f-12 mb-0 text-black ${conversation.from !== "appUser" ? "" : ""}`}>{conversation?.message}</p>
                </div>
                <p className={`f-12 mb-0 text-color ${conversation.from !== "appUser" ? "" : "text-end"}`}>
                  {moment(conversation?.dateAndTime).format("DD/MM/YYYY hh:mm A")}
                </p>
              </div>
            )
          })
        }
        <div ref={chatEndRef} />
      </div>
     </div>
     {(ticketInfo?.status?.toLowerCase() === "pending" || ticketInfo?.status?.toLowerCase() === "replied" || ticketInfo?.status?.toLowerCase() === "in progress") ?
        <div className='send-msg d-flex mt-4'  style={{
          position: "fixed",
          bottom: "13px",
          background: "#111622",  
          zIndex: 1000,  
          width:"91%",
          padding: "10px" // Optional: padding around the input area
        }}>
          <input placeholder='type your message' value={inputMessage} onChange={(e) => setInputMessage(e.target.value)} onKeyPress={handleKeyPress} />
          <span onClick={() => handlerSendMessage()}>
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
              <path d="M18.5452 0.433555C18.3401 0.24015 18.0828 0.10418 17.8017 0.040597C17.5205 -0.0229756 17.2263 -0.0117109 16.9515 0.0731659L1.08964 5.09802C0.795469 5.18654 0.535522 5.35588 0.342622 5.58464C0.149721 5.81339 0.0325303 6.09131 0.00584824 6.38329C-0.0208339 6.67527 0.0441854 6.96817 0.192699 7.22508C0.341223 7.48198 0.566563 7.69132 0.840279 7.82672L7.42136 10.9158L10.6739 17.1865C10.8047 17.4319 11.0047 17.6381 11.2517 17.7817C11.4987 17.9253 11.783 18.0009 12.0726 18H12.181C12.4912 17.9783 12.7873 17.8685 13.0309 17.6848C13.2745 17.5012 13.4544 17.2522 13.5471 16.9703L18.9139 1.94719C19.0097 1.68764 19.026 1.40757 18.9607 1.1396C18.8954 0.871634 18.7513 0.626785 18.5452 0.433555ZM1.76185 6.51898L15.607 2.13253L7.92009 9.43303L1.76185 6.51898ZM12.1485 16.3731L9.06934 10.5245L16.7563 3.224L12.1485 16.3731Z" fill="#82838E" />
            </svg>
          </span>
        </div>
        : <></>
      }
    </>
  )
}

export default TicketDetailPage